import { ExcelProcessor } from './excel-processor';

const processor = new ExcelProcessor();
let currentItems: any[] = [];

Office.onReady((info) => {
    if (info.host === Office.HostType.Excel) {
        document.getElementById("sendButton").addEventListener("click", sendData);
        logToUI("Я запустился");
        loadItems();
    }

    const debugToggle = document.getElementById('debug-toggle') as HTMLInputElement;
    const debugOutput = document.getElementById('debug-output');

    // Восстановление состояния из localStorage
    const savedState = localStorage.getItem('debugVisible');
    if (savedState) {
        debugToggle.checked = savedState === 'true';
        updateDebugVisibility();
    }

    // Обработчик изменения чекбокса
    debugToggle.addEventListener('change', () => {
        localStorage.setItem('debugVisible', debugToggle.checked.toString());
        updateDebugVisibility();
    });

    function updateDebugVisibility() {
        if (debugToggle.checked) {
            debugOutput?.classList.remove('debug-hidden');
            debugOutput?.classList.add('debug-visible');
        } else {
            debugOutput?.classList.remove('debug-visible');
            debugOutput?.classList.add('debug-hidden');
        }
    }    
});



function logToUI(message: string, isError = false) {
    const debugOutput = document.getElementById('debug-output');
    if (!debugOutput) return;

    const messageElement = document.createElement('div');
    messageElement.textContent = `[${new Date().toLocaleTimeString()}] ${message}`;
    
    if (isError) {
        messageElement.style.color = 'red';
    }

    debugOutput.appendChild(messageElement);
    debugOutput.scrollTop = debugOutput.scrollHeight;
}

async function loadItems() {
    try {
        logToUI("Пытаюсь загрузить таблицу");
        const tableRange = await processor.findTable();
        logToUI(`Нашел таблицу в строках с ${tableRange.startRow} до ${tableRange.endRow}`);
        const itemsCount = await processor.getItemsCount(tableRange);
        const itemsList = document.getElementById("itemsList");
        itemsList.innerHTML = "";
        
        currentItems = [];

        logToUI(`Найдено ${itemsCount} позиций`);
        
        for (let i = 1; i <= itemsCount; i++) {
            const item = await processor.getItem(i, tableRange);
            currentItems.push(item);
            
            const row = document.createElement("tr");
            row.addEventListener("click", () => showItemDetails(i));
            
            const indexCell = document.createElement("td");
            indexCell.textContent = item.index;
            
            //const sectionCell = document.createElement("td");
            //sectionCell.textContent = `Раздел № ${item.razdel}`;
            
            const nameCell = document.createElement("td");
            nameCell.textContent = item.name;
            
            row.appendChild(indexCell);
            //row.appendChild(sectionCell);
            row.appendChild(nameCell);
            itemsList.appendChild(row);
        }
        
        // Select first item by default
        if (itemsCount > 0) {
            // showItemDetails(1);
        }
    } catch (error) {
        console.error("Error loading items:", error);
        logToUI("Error loading items from Excel");
    }
}

function showItemDetails(index: number) {
    const item = currentItems[index - 1];
    if (!item) return;
    
    document.getElementById("fullName").textContent = item.name;
    document.getElementById("price").textContent = item.price;
    document.getElementById("count").textContent = item.count;
    // document.getElementById("noNDS").textContent = item.price; // Adjust as needed
    // document.getElementById("nds").textContent = "20%"; // Adjust as needed
    // document.getElementById("priceNDS").textContent = 
        // (parseFloat(item.price) * 1.2).toFixed(2); // Adjust as needed
}

async function sendData() {
    logToUI("Пытаюсь отправить данные в 1С");
    try {
        const tableRange = await processor.findTable();
        const jsonData = await processor.generateJSON(tableRange);
        logToUI(jsonData);
        await processor.sendData(jsonData);
    } catch (error) {
        console.error("Error sending data:", error);
        logToUI("Error sending data to server");
    }
}

function showError(message: string) {
    // Implement error display logic
    alert(message);
}